/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Eye Closed",
  size: 20
}

const SvgEyeClosed = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M10 15c-2.946 0-5.612-1.667-8-5 2.388-3.333 5.054-5 8-5 2.946 0 5.612 1.667 8 5-2.388 3.333-5.054 5-8 5zm0-1c2.577 0 4.81-1.333 6.698-4C14.81 7.333 12.578 6 10 6 7.423 6 5.206 7.33 3.35 9.99 5.206 12.663 7.423 14 10 14z" />
    <path d="M10 13a3 3 0 110-6 3 3 0 010 6zm0-1a2 2 0 100-4 2 2 0 000 4z" />
    <path d="M15.157 4.136l.707.707L4.799 15.886l-.707-.708z" />
  </Svg>
)

SvgEyeClosed.defaultProps = defaultProps
export default SvgEyeClosed
